export const APP_VERSION = '1.26.1';
